

import {
    Component,
    OnInit,
  } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
  import { NGXLogger } from "ngx-logger";
  import { MenuItem, MessageService } from "primeng/api";
  import {
    collection,
    query,
    where,
    getDocs,
    onSnapshot,
    Firestore,
    GeoPoint,
  } from "firebase/firestore";
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { BocciaturaConsegnaFase1 } from "src/app/models/dto/bocciaturaFase1.model";
import { PreventivoFase1DTO } from "src/app/models/dto/preventivoFase1.model";
import { SopralluogoFase1DTO } from "src/app/models/dto/sopralluogoFase1.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { ExcelService } from "src/app/services/excelService.service";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { PraticheScuolaService } from "src/app/services/pratiche.scuola.service";
import { PraticheService } from "src/app/services/pratiche.service";
import * as Leaflet from "leaflet";
import { environment } from "src/environments/environment";
import { AngularFirestore } from "@angular/fire/compat/firestore";

  

@Component({
    selector: "component-modifica-posizione-scuola",
    templateUrl: "./dialog-modifica-posizione-scuola.component.html",
    styleUrls: ["../shared.component.css"],
  })
  export class ModificaPosizioneScuola implements OnInit {

    protected _onDestroy = new Subject<void>();
    protected pratica: PraticaFlowdy2_Firestore;
    private collection_pratiche_scuola:string = environment.firebase.collection_pratiche;
    protected positionHasChanged:boolean = false;

    protected coordinateOriginali:GeoPoint;
    protected nuoveCoordinate:GeoPoint;

    protected map!: Leaflet.Map;
    protected markers: Leaflet.Marker[] = [];
    protected options = {
      layers: [
        Leaflet.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
          attribution:
            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
        }),
      ],
      zoom: 14,
      center: { lat: 28.626137, lng: 79.821603 },
    };
  
    
    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private firestoreService:AngularFirestore,
          
    ) {
      this.pratica          = this.config.data.pratica;
     
    }
    ngOnInit() {
    }

    initMarkers() {
      this.coordinateOriginali = new GeoPoint(this.pratica.coordinateScuola.latitude.valueOf(),this.pratica.coordinateScuola.longitude.valueOf());

        const initialMarkers = [
          {
            position: {
              lat: this.pratica.coordinateScuola.latitude.valueOf(),
              lng: this.pratica.coordinateScuola.longitude.valueOf(),
            },
            draggable: true,
          },
        
        ];
        const dataScuola = initialMarkers[0];
        const markerScuola = this.generateMarker(dataScuola, 0, true);
        let popupScuola = "SCUOLA <b> "+ this.pratica.denominazione + "</b><br>" +
                          this.pratica.indirizzo + "<br>"+
                          "<b>" + this.pratica.comune + "</b><br>";
        
     
        markerScuola.addTo(this.map).bindPopup(popupScuola);
        this.markers.push(markerScuola);
        this.logger.info(dataScuola);
        
        this.map.panTo(dataScuola.position);
    
      }
    
      markerOver(event: any, index: number){
        const marker = event.target;
        marker.openPopup();
      }
      markerOut(event, index) {
        const marker = event.target;
        marker.closePopup();
      }
      generateMarker(data: any, index: number, isScuola:boolean) {
        let markerIconScuola = new Leaflet.Icon({
          iconUrl: '/assets/leaflet/images/marker-icon-bando2.png',
          //iconSize: [40, 25],
          iconSize: [25, 41],
        });
        let markerIconCentrale= new Leaflet.Icon({
          iconUrl: '/assets/leaflet/images/marker-icon-centrale.png',
        iconSize: [25, 41],
        });
        if(isScuola){
          return Leaflet.marker(data.position, { draggable: data.draggable, icon:markerIconScuola })
            //.on("click", (event) => this.markerClicked(event, index))
            .on("mouseover", (event) => this.markerOver(event, index))
            .on("mouseout", (event) => this.markerOut(event, index))
            .on("dragend", (event) => this.markerDragEnd(event, index));
        }else{
          return Leaflet.marker(data.position, { draggable: data.draggable, icon:markerIconCentrale })
         // .on("click", (event) => this.markerClicked(event, index))
          .on("mouseover", (event) => this.markerOver(event, index))
          .on("mouseout", (event) => this.markerOut(event, index))
          .on("dragend", (event) => this.markerDragEnd(event, index));
        }
        
      }
      markerClicked($event: any, index: number) {}
    
      markerDragEnd($event: any, index: number) {
         this.logger.info("NUOVE COORDINATE " + $event.target._latlng.lat + " "+ $event.target._latlng.lng);
         this.nuoveCoordinate = new GeoPoint($event.target._latlng.lat,$event.target._latlng.lng );
         this.positionHasChanged = true;
      }
      onMapReady($event: Leaflet.Map) {
        this.map = $event;
        this.initMarkers();
      }
    
      mapClicked($event: any) {}

      conferma(conferma:boolean){
        if(!conferma){
          this.dialogRef.close({ success: false });
         /*  const collectionRef = this.firestoreService.collection(this.collection_pratiche_scuola);
          const documentRef = collectionRef.doc(this.pratica.cui.valueOf());
          let updatedData:any ;// { coordinateScuola: nuoveCoordinate };
          updatedData  = { coordinateScuola : this.coordinateOriginali };
          
          documentRef
            .update(updatedData)
            .then(() => {
              this.logger.info( "OK AGGIORNAMENTO COORDINATE SU FIRESTORE");
              
            })
            .catch((error) => {
              this.logger.error(
                "ERRORE AGGIORNATO COORDINATE SU FIRESTORE"
              );
            }); */
        }else{
          const collectionRef = this.firestoreService.collection(this.collection_pratiche_scuola);
            const documentRef = collectionRef.doc(this.pratica.cui.valueOf());
            let updatedData:any ;// { coordinateScuola: nuoveCoordinate };
            updatedData  = { coordinateScuola : this.nuoveCoordinate };
            
         
            documentRef
              .update(updatedData)
              .then(() => {
                this.logger.info( "OK AGGIORNAMENTO COORDINATE SU FIRESTORE");
                this.dialogRef.close({ success: true });
              })
              .catch((error) => {
                this.logger.error(
                  "ERRORE AGGIORNATO COORDINATE SU FIRESTORE"
                );
              });
        }
       
      }

  }